export default __webpack_public_path__ + "static/media/Private_Equity_20221103.fec7ab06.pdf";